import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw Route.redirect({ to: '/chat', replace: true, statusCode: 302 });
  },
});
